import React, { useEffect, useState, useRef } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Container, Breadcrumb, Grid, Header, Button, Icon, Image, Form, Input } from 'semantic-ui-react';
import { getIconListList } from '../../../Services/AdminServices';
import Swal from 'sweetalert2';
import axios from 'axios';
type IconSelectorProps = {
    onChange: Function;
    value: string;
}

type IconListResponse = string[];


export const IconSelector: React.FC<IconSelectorProps> = (props) => {

    const [data, setData] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isListOpen, setIsListOpen] = useState<boolean>(false);
    const [selectedIconName, setSelectedIconName] = useState<string>(props.value);
    const [inputKey, setInputKey] = useState<number>(0);

    useEffect(() => {
        if(props.value && props.value !== selectedIconName){
            setSelectedIconName(props.value);
        }
    }, [props.value]);

    function handleLoadIcon() {
        _fatchData();
        setIsListOpen(true);
    }

    function resetFileInput() {
        setInputKey((prevValue) => {
            return prevValue + 1;
        });
    }

    function handleUploadIcon() {
        let inputElement: HTMLElement | null = document.getElementById('icon-uploader');
        if (inputElement) {
            inputElement.click();
        }
    }

    function handleBackdropClick() {
        setIsListOpen(false);
    }

    function handleChange() {
        let inputElement: HTMLElement | null = document.getElementById('icon-uploader');
        if (inputElement) {
            let files = (inputElement as HTMLInputElement).files;
            if (files && files.length > 0) {
                let myData = new FormData();
                myData.append('file', files[0]);
                myData.append('replace', "false");
                setIsLoading(true);
                axios({
                    method: "post",
                    url: "/Admin/UploadIcon",
                    data: myData,
                    headers: { "Content-Type": "multipart/form-data" },
                })
                    .then(function (response) {
                        //handle success
                        //console.log(response);
                        setIsLoading(false);
                        if (response.data === true) {
                            Swal.fire({
                                title: 'Replace File?',
                                text: "File with same name already exist, would you like to replace it?",
                                icon: 'warning',
                                showCancelButton: true,
                                cancelButtonText: 'Cancel',
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'Replace'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    let newData = new FormData();
                                    // @ts-expect-error files[0] sure exist.
                                    newData.append('file', files[0]);
                                    newData.append('replace', "true");
                                    setIsLoading(true);
                                    axios({
                                        method: "post",
                                        url: "/Admin/UploadIcon",
                                        data: newData,
                                        headers: { "Content-Type": "multipart/form-data" },
                                    }).then((response2) => {
                                        setIsLoading(false);
                                        toastSuccessMessage('File upload completed.');
                                    });
                                }else {
                                    // canceled
                                }
                            })
                        } else {
                            toastSuccessMessage('File upload completed.');
                        }
                        resetFileInput();
                    })
                    .catch(function (response) {
                        //handle error
                        console.log(response);
                        setIsLoading(false);
                    });
            }
        }
    }

    function toastSuccessMessage(message: string) {
        Swal.fire({
            icon: 'success',
            position: 'top-end',
            title: 'Success',
            text: message,
            timer: 5000,
            toast: true,
            timerProgressBar: true,
            showConfirmButton: false,
            showCancelButton: false,
        })
    }

    function handleSelectItem(iconName: string) {
        console.log(iconName);
        setSelectedIconName(iconName);
    }

    function _fatchData() {
        try {
            setIsLoading(true);
            getIconListList().then((response) => {
                setIsLoading(false);
                if (response.status === 200 && response.data) {
                    let data = response.data as IconListResponse;
                    if (data.length > 0) {
                        setData(data);
                    }

                } else {
                    throw new Error('Unable to fetch icon list data!');
                }
            });
        } catch (error) {
            setIsLoading(false);
            Swal.fire(
                {
                    icon: 'error',
                    title: 'Error While Processing',
                    text: `Unable to get master data for the form.`,
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                    confirmButtonColor: '#1678c2'
                }
            ).then(() => {
            });
        }

    }

    return (<div className='icon-selector-input'>
        {
            selectedIconName !== '' &&
            <div>
                {selectedIconName}
            </div>
        }
        {
            selectedIconName !== '' &&
            <Image className='icon-selector-preview-image' src={
                `${process.env.REACT_APP_VIRTUAL_DIRECTORY}/assets/images/svg/${selectedIconName}`
            } size='small' />
        }
        <Button type='button' icon loading={isLoading} onClick={handleLoadIcon}>
            <Icon name='file image' />
            Select {selectedIconName != "" ? 'Another' : 'Existing'} Icon
        </Button>
        <div style={{ marginRight: '0.5rem' }}><b>Or</b></div>
        <Button type='button' icon loading={isLoading} onClick={handleUploadIcon}>
            <Icon name='upload' />
            Upload icon file
        </Button>
        {
            isListOpen &&
            <div className='icon-selector-backdrop' onClick={handleBackdropClick}>
                <div className='icon-selector-container' onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}>
                    <div className='icon-selector-header'><h4>Select an icon</h4></div>

                    <div className='icon-selector-content'>
                        <div className='icon-selector-inner-content'>
                            {
                                data.map((item, index) => {
                                    return <div key={index}
                                        className={'icon-selector-icon-item' + (selectedIconName === item ? " selected" : '')}
                                        onClick={() => { handleSelectItem(item) }}
                                    >
                                        <Image className='icon-selector-icon-image' src={
                                            `${process.env.REACT_APP_VIRTUAL_DIRECTORY}/assets/images/svg/${item}`
                                        } size='small' />
                                        <div className='icon-selector-icon-title'>{item}</div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                    <div className='icon-selector-footer'>
                        <Button type='button'
                            size='small'
                            primary
                            onClick={() => {
                                props.onChange(selectedIconName);
                                setIsListOpen(false);
                            }}>
                            Select
                        </Button>
                        <Button type='button'
                            size='small'
                            onClick={handleBackdropClick}>
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        }
        <div style={{ display: 'none' }} key={inputKey}>
            <input type='file' id='icon-uploader' accept='.svg' onChange={() => {
                handleChange()
            }}></input>
        </div>

    </div>);
}